var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopySvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 11H7C6.44688 11 6 10.5531 6 10V2C6 1.44687 6.44688 1 7 1H10.3781C10.5094 1 10.6375 1.05313 10.7312 1.14688L12.8531 3.26875C12.9469 3.3625 13 3.49063 13 3.62188V10C13 10.5531 12.5531 11 12 11ZM13.5594 2.55938L11.4406 0.440625C11.1594 0.159375 10.7781 0 10.3813 0H7C5.89687 0 5 0.896875 5 2V10C5 11.1031 5.89687 12 7 12H12C13.1031 12 14 11.1031 14 10V3.62188C14 3.225 13.8406 2.84375 13.5594 2.5625V2.55938ZM2 4C0.896875 4 0 4.89687 0 6V14C0 15.1031 0.896875 16 2 16H7C8.10312 16 9 15.1031 9 14V13H8V14C8 14.5531 7.55312 15 7 15H2C1.44687 15 1 14.5531 1 14V6C1 5.44688 1.44687 5 2 5H4V4H2Z",
    fill: "#3FBEEA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopySvg);
export default __webpack_public_path__ + "static/media/copy-svg.a3bff900c0f98a570a6d427051ba6dea.svg";
export { ForwardRef as ReactComponent };